module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("64Z7N"))).then(() => module.bundle.root('8rm4T'));